import Symbol from './symbol.js'
import * as colors from 'scoreboard-colors'

export default class Symbol2d extends Symbol {

  /*
   * Default paths for a 2d symbol, which only has one path.
   * The gradient runs from top to bottom.
   */
  getPaths (data, dimensions, handles) {
    const color = data.color
    const id = `${this.id}-0-component`
    const fill = this.getFillValue(id, data.fill, color)

    return [{
      path: this.path(dimensions, handles),
      id,
      fill,
      gradient: {
        type: 'linearGradient',
        x1: '0%',
        y1: '0%',
        x2: '0%',
        y2: '100%',
        stops: [
          { offset: '0%', color: colors.adjustLightness(color, 50) },
          { offset: '40%', color },
          { offset: '60%', color },
          { offset: '100%', color: colors.adjustLightness(color, -15) },
        ]
      }
    }]
  }

}
